import { render, staticRenderFns } from "./DonutChart08.vue?vue&type=template&id=408e2258&scoped=true"
import script from "./DonutChart08.vue?vue&type=script&lang=js"
export * from "./DonutChart08.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408e2258",
  null
  
)

export default component.exports